interface OffcanvasEvent extends Event {
  relatedTarget: HTMLElement | null
}

let activeTriggerButton: HTMLElement | null = null

document.addEventListener('show.te.offcanvas', (event) => {
  document.documentElement.classList.add('overflow-hidden')

  const offcanvasEvent = event as OffcanvasEvent

  activeTriggerButton = (offcanvasEvent.relatedTarget || document.activeElement) as HTMLElement
})

document.addEventListener('hide.te.offcanvas', () => {
  document.documentElement.classList.remove('overflow-hidden')
})

// TW elements don't automatically receive focus when shown, so we need to set it manually for accessibility
document.addEventListener('shown.te.offcanvas', (event) => {
  const dialog = event.target as HTMLElement
  const closeButton = dialog.querySelector('[data-te-offcanvas-dismiss]') as HTMLElement
  if (closeButton) {
    closeButton.focus()
  } else {
    // Fallback: If no close button is found, focus the dialog container itself
    dialog.focus()
  }
})

// Return focus to the trigger button when the offcanvas is hidden
document.addEventListener('hidden.te.offcanvas', () => {
  if (activeTriggerButton) {
    activeTriggerButton.focus()

    activeTriggerButton = null
  }
})
